import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const Index = lazy(() => import('components/productModule/manufacturer/Index'));
const Manufacturer = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<Index />;
			</Suspense>
		</div>
	);
};
export default Manufacturer;
